import React,{useState,useEffect,useContext} from 'react'
import BranchContext from "./../context/branch";
import {getqueueplan} from '../../services/wms'
import Renderdata from './renderplan'
import moment  from 'moment';
import DatePicker from "react-datepicker";
const Plane = () => {
    const { currentBranch } = useContext(BranchContext);
    const [queuedate, setQueuedate] = useState(new Date());
    const [queuelist, setqueuelist] = useState([]);
    const [currenttime, setcurrenttime] = useState('00:00');
    const [loading, setloading] = useState(false);
    const [total, settotal] = useState({
        all: 0,
        truckin: 0,
        waiting: 0,
        truckout: 0,
        over: 0,
        cancel: 0,
        swap: 0,
        travel: 0,
      });

  useEffect(() => {
    if (currentBranch._id === "") return;

    setloading(true);
    const loadPrivilege = async () => {
      const { data: result } = await getqueueplan(
        moment(queuedate, "YYYY-MM-DD").add(0, "day").format("YYYY-MM-DD"), currentBranch._id
      );
      if (result.status === "success") {
        setqueuelist(result.data.list);
        setcurrenttime(result.data.current);
        settotal({
            all:
              result.data.total.id0 +
              result.data.total.id1 +
              result.data.total.id2 +
              result.data.total.id3 +
              result.data.total.id4 ,
            truckin: result.data.total.id1,
            waiting: result.data.total.id0,
            truckout: result.data.total.id2,
            over: result.data.total.id3,
            cancel: result.data.total.id4
            
          });
        // setcurrenttime(result.data.current);

        // settotal({
        //   all:
        //     result.data.total.id0 +
        //     result.data.total.id1 +
        //     result.data.total.id2 +
        //     result.data.total.id3 +
        //     result.data.total.id4 +
        //     result.data.total.id5 +
        //     result.data.total.id6,
        //   truckin: result.data.total.id1,
        //   waiting: result.data.total.id0,
        //   truckout: result.data.total.id2,
        //   over: result.data.total.id3,
        //   cancel: result.data.total.id4,
        //   travel: result.data.total.id5,
        //   swap: result.data.total.id6,
        // });

        setloading(false);
      } else if (result.status === "error") {
        // toast.error(result.message);
        setloading(false);
      }
    };
    loadPrivilege();
  }, [currentBranch._id, queuedate]);

  const handleonClick = (event) => {

  }
  const handleChangStartDate = (event) => {
    setQueuedate(event)
  }
    return (  
<>
<div>


            <div className="row m-2">
              {" "}
              <div className="col-auto  text-center  mx-2">
                <span className="text-dark">วันที่</span>

                <div

                // style={{ marginTop: 20, marginBottom: 20 }}
                >
                  <DatePicker
                    className="datepicker-default form-control "
                    todayButton="Today"
                    dateFormat="dd/MM/yyyy"
                    selected={queuedate}
                    onChange={handleChangStartDate}
                  />
                </div>
                </div>   
              </div>


      <div className="row  m-2 ">

       
     

        <div className="col-auto mb-2 p-1">
          <span
            className="badge  bg-warning text-dark"
            style={{ fontSize: "13px", cursor: "pointer" }}
          >
            {"รอชั่ง"} {total.waiting}
          </span>
        </div>

        <div className="col-auto mb-2 p-1">
          <span
            className="badge bg-success"
            style={{ fontSize: "13px", cursor: "pointer" }}
          >
            {"ชั่งเข้า"} {total.truckin}
          </span>
        </div>

        <div className="col-auto mb-2 p-1">
          <span
            className="badge "
            style={{
              fontSize: "13px",
              cursor: "pointer",
              background: "#4E6C50",
            }}
          >
            {"ชั่งออก"} {total.truckout}
          </span>
        </div>

        <div className="col-auto mb-2 p-1">
          <span
            className="badge bg-danger"
            style={{ fontSize: "13px", cursor: "pointer" }}
          >
            {"ตกคิว"} {total.over}
          </span>
        </div>

        <div className="col-auto mb-2 p-1">
          <span
            className="badge  bg-primary"
            style={{ fontSize: "13px", cursor: "pointer" }}
          >
            {"Total"} {total.all}
          </span>
          </div>
        </div>
        <div className='card ms-2'>
             <Renderdata
                            
              list={queuelist}
               current={currenttime}
              handleonClick={handleonClick}
            />
        </div>

           
          </div>
</>

    );
}
 
export default Plane;